import ItemDashboardView from "components/dashboard/ItemDashboardView";
import ItemDashboard from "model/dashboard/ItemDashboard";
import { ScrollPanel } from "primereact/scrollpanel";
import { useEffect, useState } from "react";
import DashboardService from "service/dashboard/DashboardService";

const dashboardService = new DashboardService();
export default function DashboardGeralPage() {

    const [itensDashboard, setItensDashboard] = useState<Array<ItemDashboard>>([]);

    useEffect(() => {
        dashboardService.itensDashboard().then((response) => {
            setItensDashboard(response);
        }).catch((err) => {
            console.log(err);
        });
    }, [])


    return (
        <div style={{display: "flex", flexDirection:"column", rowGap: 10, width: "100%"}}>

            <ScrollPanel style={{width: "100%"}} >
                <div style={{ display: "flex", width: "100%", columnGap: 20 }}>
                    {itensDashboard.map((item, index) => {
                        return (
                            item.tipo.includes("INDICADOR") && <div key={index}>
                                <ItemDashboardView value={item} />
                            </div>
                        )
                    })}
                </div>
            </ScrollPanel>
            <div style={{ display: "flex", width: "100%", columnGap: 20, flexWrap: "wrap" }}>
                {itensDashboard.map((item, index) => {
                    return (
                        item.tipo.includes("GRAFICO") && <div key={index}>
                             <ItemDashboardView value={item} />
                        </div> 
                    )
                })}
            </div>
        </div>

    )
}